export default {
  primary: {
    main: '#2c69ef',
  },
  secondary: {
    main: '#E0E0E0',
  },
  info: {
    main: '#2196F3',
  },
};
